var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDetailItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#FDE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.46C9.5 7.12397 9.5 6.95595 9.56812 6.82761C9.62804 6.71471 9.72365 6.62292 9.84126 6.5654C9.97495 6.5 10.15 6.5 10.5 6.5H13.5C13.85 6.5 14.025 6.5 14.1587 6.5654C14.2763 6.62292 14.372 6.71471 14.4319 6.82761C14.5 6.95595 14.5 7.12397 14.5 7.46V7.94C14.5 8.27603 14.5 8.44405 14.4319 8.57239C14.372 8.68529 14.2763 8.77708 14.1587 8.8346C14.025 8.9 13.85 8.9 13.5 8.9H10.5C10.15 8.9 9.97495 8.9 9.84126 8.8346C9.72365 8.77708 9.62804 8.68529 9.56812 8.57239C9.5 8.44405 9.5 8.27603 9.5 7.94V7.46Z",
    fill: "#FFA6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.7C15.0812 7.7 15.3718 7.7 15.6103 7.76133C16.2573 7.92777 16.7627 8.41296 16.9361 9.03413C17 9.26303 17 9.54202 17 10.1V15.62C17 16.6281 17 17.1321 16.7956 17.5172C16.6159 17.8559 16.329 18.1312 15.9762 18.3038C15.5751 18.5 15.0501 18.5 14 18.5H10C8.9499 18.5 8.42485 18.5 8.02377 18.3038C7.67096 18.1312 7.38413 17.8559 7.20436 17.5172C7 17.1321 7 16.6281 7 15.62V10.1C7 9.54202 7 9.26303 7.06389 9.03413C7.23726 8.41296 7.74267 7.92777 8.38971 7.76133C8.62815 7.7 8.91877 7.7 9.5 7.7M10.125 14.3L11.375 15.5L14.1875 12.8M10.5 8.9H13.5C13.85 8.9 14.025 8.9 14.1587 8.8346C14.2763 8.77708 14.372 8.68529 14.4319 8.57239C14.5 8.44405 14.5 8.27603 14.5 7.94V7.46C14.5 7.12397 14.5 6.95595 14.4319 6.82761C14.372 6.71471 14.2763 6.62292 14.1587 6.5654C14.025 6.5 13.85 6.5 13.5 6.5H10.5C10.15 6.5 9.97495 6.5 9.84126 6.5654C9.72365 6.62292 9.62804 6.71471 9.56812 6.82761C9.5 6.95595 9.5 7.12397 9.5 7.46V7.94C9.5 8.27603 9.5 8.44405 9.56812 8.57239C9.62804 8.68529 9.72365 8.77708 9.84126 8.8346C9.97495 8.9 10.15 8.9 10.5 8.9Z",
    stroke: "url(#paint0_linear_527_6590)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_527_6590",
    x1: 7,
    y1: 6.5,
    x2: 17.1717,
    y2: 6.64736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetailItem);
export default __webpack_public_path__ + "static/media/IconDetailItem.b88ff0f8a0ae04263ff204998f8b77ea.svg";
export { ForwardRef as ReactComponent };